import React from "react";
import * as yup from "yup";

import Form from "@Components/Form";
import { URLS, COMPANY_URL } from "configs/constants";
import { SOURCE_FETCH_URL } from "configs/constants";

const initialValues = {
  name: "",
  active: true,
  source: "",
};

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required") 
    .matches(/^[a-zA-Z0-9.()/\- ]+$/, "Special characters are not allowed"),
  active: yup.boolean(),
});
const CompanyForm = () => {
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
      disabledText: ["APL", "FGVAS", "FGVPM", "PUP", "YM"],

    },
    {
        type: "reactselect",
        name: "source",
        label: "Source",
        required: true,
        proxyUrl: SOURCE_FETCH_URL,
        paginated: true,
        gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },

        
      },
    {
      name: "active",
      type: "switch",
      label: "Status",
      color: "primary",
      gridSize: { xs: 12 },
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];


  return (
    <Form
      initialValues={initialValues}
      submitUrl={COMPANY_URL}
      validationSchema = {validationSchema}
      listRoute={URLS.COMPANY_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Company"
    />
  );
};

export default CompanyForm;
